import React from 'react';
import { WIDGET_TRANSLATION_NAMESPACE } from 'consts';
import { EnelXGuiAtoms } from 'gui';
import { t } from 'i18n';
import styled from 'styled-components';

const LabelText = styled.span`
  font-size: 11px;
  color: ${(p) => p?.theme.colors.primary.textGrey};
  border: 2px solid ${(p) => p?.theme.colors.primary.grey};
  border-radius: 5px;
  padding: 3px 5px;
  height: fit-content;
`;

export const Last30DaysLabel = () => <LabelText>{t('last30')}</LabelText>;

const {
  InformationTooltip,
} = EnelXGuiAtoms;

const InfoTooltipContainer = styled.div`
  display: flex;
  align-items: center;
`;

const infoTooltipComponent = (text, isDetail) => (
  <InfoTooltipContainer>
    <InformationTooltip
      text={text}
    />
    {isDetail ? <Last30DaysLabel /> : null}
  </InfoTooltipContainer>
);

const sessionTooltipInfo = (disclamer = false) => (
  <>
    <b>{`${t('widgets.sessionTooltipInfo1')}:`}</b>
    <ul>
      <li>{t('widgets.sessionTooltipInfo2')}</li>
      <li>{t('widgets.sessionTooltipInfo3')}</li>
    </ul>
    {disclamer ? <p>{t('widgets.kpiDisclamer')}</p> : null}
  </>
);

const textWrapper = (text = null, subText = null) => (
  <div style={{ maxWidth: '30rem' }}>
    {text ? <b>{t(`${WIDGET_TRANSLATION_NAMESPACE}.${text}`)}</b> : null}
    {subText ? <p>{t(`${WIDGET_TRANSLATION_NAMESPACE}.${subText}`)}</p> : null}
  </div>
);

const publicCostTooltipInfo = () => textWrapper('costPublicTooltipInfo', 'kpiDisclamer');

const privateCostTooltipInfo = () => textWrapper('costPrivateTooltipInfo', 'kpiDisclamer');

const reimbursementTooltipInfo = () => textWrapper('reimbursementTooltipInfo', 'kpiDisclamer');

const totalCostTooltipInfo = () => textWrapper('costTotalTooltipInfo', 'kpiDisclamer');

const totalCo2TooltipInfo = (showDisclaimer) => textWrapper('totalCo2TooltipInfo', showDisclaimer ? 'kpiDisclamer' : null);

const publicCo2TooltipInfo = () => textWrapper('publicCo2TooltipInfo', 'kpiDisclamer');

const privateCo2TooltipInfo = () => textWrapper('privateCo2TooltipInfo', 'kpiDisclamer');

const residentialCo2TooltipInfo = () => textWrapper('residentialCo2TooltipInfo', 'kpiDisclamer');

const totalTreesTooltipInfo = () => textWrapper('totalTreesTooltipInfo', 'kpiDisclamer');

const publicTreesTooltipInfo = () => textWrapper('publicTreesTooltipInfo', 'kpiDisclamer');

const privateTreesTooltipInfo = () => textWrapper('privateTreesTooltipInfo', 'kpiDisclamer');

const residentialTreesTooltipInfo = () => textWrapper('residentialTreesTooltipInfo', 'kpiDisclamer');

const energyTooltipInfo = (showDisclaimer) => textWrapper(null, showDisclaimer ? 'kpiDisclamer' : null);

export const sessionTooltip = () => infoTooltipComponent(sessionTooltipInfo());

export const publicCostTooltip = () => infoTooltipComponent(publicCostTooltipInfo());

export const privateCostTooltip = () => infoTooltipComponent(privateCostTooltipInfo());

export const reimbursementTooltip = () => infoTooltipComponent(reimbursementTooltipInfo());

export const totalCostTooltip = () => infoTooltipComponent(totalCostTooltipInfo());

export const totalCo2Tooltip = (showDisclaimer) => infoTooltipComponent(totalCo2TooltipInfo(showDisclaimer));

export const publicCo2Tooltip = () => infoTooltipComponent(publicCo2TooltipInfo());

export const privateCo2Tooltip = () => infoTooltipComponent(privateCo2TooltipInfo());

export const residentialCo2Tooltip = () => infoTooltipComponent(residentialCo2TooltipInfo());

export const totalTreesTooltip = () => infoTooltipComponent(totalTreesTooltipInfo());

export const publicTreesTooltip = () => infoTooltipComponent(publicTreesTooltipInfo());

export const privateTreesTooltip = () => infoTooltipComponent(privateTreesTooltipInfo());

export const residentialTreesTooltip = () => infoTooltipComponent(residentialTreesTooltipInfo());

export const sessionTooltipDetail = () => infoTooltipComponent(sessionTooltipInfo(), true);

export const publicCostTooltipDetail = () => infoTooltipComponent(publicCostTooltipInfo(), true);

export const privateCostTooltipDetail = () => infoTooltipComponent(privateCostTooltipInfo(), true);

export const reimbursementTooltipDetail = () => infoTooltipComponent(reimbursementTooltipInfo(), true);

export const totalCostTooltipDetail = () => infoTooltipComponent(totalCostTooltipInfo(), true);

export const energyTooltipDetail = (showDisclaimer) => infoTooltipComponent(energyTooltipInfo(showDisclaimer), true);

export default {
  energyTooltipDetail,
  privateCo2Tooltip,
  privateCostTooltip,
  privateCostTooltipDetail,
  privateTreesTooltip,
  publicCo2Tooltip,
  publicCostTooltip,
  publicCostTooltipDetail,
  publicTreesTooltip,
  reimbursementTooltip,
  reimbursementTooltipDetail,
  residentialCo2Tooltip,
  residentialTreesTooltip,
  sessionTooltip,
  sessionTooltipDetail,
  totalCo2Tooltip,
  totalCostTooltip,
  totalCostTooltipDetail,
  totalTreesTooltip,
};
